function blooFormatPresentmentMoney(cents, currencyCode) {
  const amount = Math.max(0, cents) / 100;

  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    return `${amount.toFixed(2)} ${currencyCode}`;
  }
}

window.blooUpdateShippingNudges = function (root = document) {
  const currency = window.Shopify && window.Shopify.currency;
  const rate = currency ? Number(currency.rate) : NaN;
  if (!currency || !currency.active || !Number.isFinite(rate) || rate <= 0) return;

  const nudges = [];
  if (root instanceof Element && root.matches('[data-bloo-cart-shipping]')) nudges.push(root);
  if (root.querySelectorAll) nudges.push(...root.querySelectorAll('[data-bloo-cart-shipping]'));

  nudges.forEach((nudge) => {
    const cartTotalCents = Number(nudge.dataset.cartTotalCents);
    const thresholdUsdCents = Number(nudge.dataset.thresholdUsdCents);
    if (!Number.isFinite(cartTotalCents) || !thresholdUsdCents) return;

    const thresholdPresentmentCents = Math.round(thresholdUsdCents * rate);
    const remainingCents = thresholdPresentmentCents - cartTotalCents;
    const progress = Math.min(100, Math.max(0, (cartTotalCents / thresholdPresentmentCents) * 100));
    const market = nudge.dataset.marketLabel || 'international';
    const thresholdLabel = nudge.dataset.thresholdLabel || 'US$180';
    const isUs = nudge.dataset.countryCode === 'US';
    const title = nudge.querySelector('[data-bloo-cart-shipping-title]');
    const copy = nudge.querySelector('[data-bloo-cart-shipping-copy]');
    const progressBar = nudge.querySelector('[data-bloo-cart-shipping-progress]');

    if (remainingCents <= 0) {
      if (title) title.textContent = `Free ${market} shipping`;
      if (copy) {
        copy.textContent = isUs
          ? 'Your cart qualifies for free standard US shipping.'
          : `Your cart has reached the ${thresholdLabel} threshold. Final eligibility is confirmed at checkout. Duties and taxes are calculated at checkout.`;
      }
    } else {
      if (title) title.textContent = `Free ${market} shipping ${thresholdLabel}+`;
      if (copy) {
        copy.textContent = `Add ${blooFormatPresentmentMoney(remainingCents, currency.active)} more for free ${market} shipping.`;
      }
    }

    if (progressBar) progressBar.style.width = `${progress}%`;
  });
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    window.blooUpdateShippingNudges(this);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    window.blooUpdateShippingNudges(this);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
